var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bp-card-title"},[_c('span',{staticClass:"bar"}),_c('span',{staticClass:"txt"},[_vm._v(_vm._s(_vm.title))]),(_vm.subTitle)?_c('span',{staticClass:"sub"},[_vm._v(_vm._s(_vm.subTitle))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }